"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScolapassInvoiceMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class ScolapassInvoiceMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "node.PAI_No_Reglt");
        const familyId = lodash_1.default.get(result, "node.FAM_ID");
        const invoiceNumber = lodash_1.default.get(result, "node.FAC_Numero_Facture");
        const date = lodash_1.default.get(result, "node.FAC_Date_Facture");
        const amount = lodash_1.default.get(result, "node.FAC_Montant");
        const pdfFileName = lodash_1.default.get(result, "node.FAC_PDF");
        return {
            id,
            familyId,
            invoiceNumber,
            date,
            amount,
            pdfFileName,
        };
    }
}
exports.ScolapassInvoiceMapper = ScolapassInvoiceMapper;
